module.exports = __webpack_public_path__ + "static/bite_ai_logo-c7912d14ed04759ca546246e05876fb4.png";